import { signal } from '@preact/signals';

/**
 * Реактивный признак мобильного вьюпорта (≤768px).
 * Используется для условного рендера нативной мобильной оболочки.
 */
const MOBILE_QUERY = '(max-width: 768px)';

function matches() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

export const isMobile = signal(matches());

if (typeof window !== 'undefined' && window.matchMedia) {
  const mq = window.matchMedia(MOBILE_QUERY);
  const onChange = (e) => {
    isMobile.value = e.matches;
  };
  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else if (mq.addListener) mq.addListener(onChange);
}
